<template>
  <l-map
    ref="mapa"
    v-if="showMap"
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    :style="mapStyle"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-marker
      :icon="icon"
      v-for="pin in computedPins"
      :key="pin.nome"
      :lat-lng.sync="pin.position"
    >
      <l-icon
        v-if="typeof pin.available === 'boolean'"
        :icon-url="
          require(`@/assets/css/img/${
            pin.available ? 'ico-verde' : 'ico-vermelho'
          }.svg`)
        "
        :shadowAnchor="[30, 30]"
        :popupAnchor="[-10, -10]"
        :iconAnchor="[40, 30]"
      ></l-icon>
      <l-popup :options="{ offset: popupPoint }">
        <div>
          <h4 class="font-popup">{{ pin.title }}</h4>
          <p class="font-popup">
            Para ver detalhes da unidade,
            <router-link
              role="button"
              class="btn btn-default btn-link"
              :to="{
                name: 'detalhe-unidade',
                params: {
                  detalhes: pin.title.replace(/\./g, '(-)')
                }
              }"
            >
              CLIQUE AQUI
            </router-link>
          </p>
        </div>
      </l-popup>
    </l-marker>
  </l-map>
</template>

<script>
import { Icon, latLng, point } from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LIcon
} from 'vue2-leaflet'

export default {
  name: 'LeafletMap',
  props: {
    mapStyle: {
      type: Object,
      default: () => ({ height: '300px', borderRadius: '10px' })
    },
    latitute: {
      type: Number,
      default: -23.9335988
    },
    longitude: {
      type: Number,
      default: -46.3286399
    },
    zoom: {
      type: Number,
      default: 11
    },
    mapOptions: {
      type: Object,
      default: () => ({
        zoomSnap: 0.5
      })
    },
    showParagraph: {
      type: Boolean,
      default: false
    },
    showMap: {
      type: Boolean,
      default: true
    },
    pins: {
      type: Array,
      default: () => []
    },
    icon: {
      type: Object,
      default: () => {
        const icon = require(`@/assets/css/img/ico-azul.svg`)
        return new Icon({
          shadowSize: undefined,
          iconUrl: icon,
          iconSize: this.dynamicSize,
          shadowAnchor: [30, 30],
          popupAnchor: [-10, -10],
          iconAnchor: [40, 30]
        })
      }
    },
    popupPoint: {
      default: () => point(0, 0)
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LIcon
  },
  data() {
    return {
      center: latLng(this.latitute, this.longitude),
      url:
        'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      withPopup: this.pins,
      withTooltip: latLng(-23.9452227, -46.3772091),
      currentZoom: this.zoom,
      currentCenter: latLng(this.latitute, this.longitude),
      router: this.$router
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    showLongText() {
      this.showParagraph = !this.showParagraph
    },
    fitPins() {
      this.$refs.mapa.fitBounds(this.getPositions)
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
    shadowAnchorDefault() {
      return [30, 30]
    },
    getPositions() {
      return this.pins.map(({ position }) => {
        return position
      })
    },
    computedPins() {
      return this.pins
    }
  }
}
</script>

<style scoped>
.font-popup {
  font-size: large;
}

.btn-link {
  color: #fff;
  border-radius: 5px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LeafletMap/index.vue